export default __webpack_public_path__ + "static/media/top-banner-image.19961fc5.png";